import { CustomAlert } from "components";
import { AdminLayout, AuthLayout, ChargeLayout, ContentLayout } from "layouts";
import { useLocation } from "react-router-dom";

type Props = {
    children: React.ReactNode;
};
export default function BaseLayout({ children }: Props) {
    const location = useLocation();

    const isAuthPage = location.pathname.startsWith("/login") || location.pathname.startsWith("/signup") || location.pathname.startsWith("/account");
    const isChargePage = location.pathname.startsWith("/charge");
    const isAdminPage = location.pathname.startsWith("/admin");

    return (
        <div className="font-pretendard w-full min-h-screen bg-canvas">
            {isAuthPage ? (
                <AuthLayout>
                    {children}
                </AuthLayout>
            ) : isChargePage ? (
                <ChargeLayout>
                    {children}
                </ChargeLayout>
            ) : isAdminPage ? (
                <AdminLayout>
                    {children}
                </AdminLayout>
            ) : (
                <ContentLayout>
                    {children}
                </ContentLayout>
            )}
            <CustomAlert />
        </div>
    );
}